import {toast} from "react-toastify"
import {pathBuilder} from "../../../anwendungskonfigurator/misc/utils"
import {downloadFileFromLink} from "../../../anwendungskonfigurator/misc/file-download"

const GRUPPEN_PTR = "/gruppenunfalleinzel/tarifierungGruppenUndEinzelUnfallList"
const PAGE_PTR = "/appstate/unfallgruppe/page"
const PER_PAGE = 3
const COURTAGE_KEY = "vorgabeMitCourtage"

const downloadDocument = (payload) => {
    const href =
        payload?._links?.loadAngebotPdf?.href ?? payload?._links?.document?.href
    return downloadFileFromLink(
        {href, methods: ["GET"]},
        payload?.tarifierungsvariante ?? "Gruppenunfall",
    )
}

export const GruppenunfallActions = ({
    navigate,
    getDataFromPointer,
    updateData,
    loadCurrentLocationData,
    sendDataToBackend,
}) => {
    return {
        GRUPPE_HINZUFUEGEN: () => {
            const gruppen = getDataFromPointer(GRUPPEN_PTR) ?? []
            updateData([...gruppen, {}], GRUPPEN_PTR)
            updateData(Math.floor(gruppen.length / PER_PAGE), PAGE_PTR)
        },
        GRUPPE_SEITE_SETZEN: (page) => {
            updateData(page, PAGE_PTR)
        },
        COURTAGE_ALLE_SETZEN: ({value}) => {
            const gruppen = getDataFromPointer(GRUPPEN_PTR) ?? []
            gruppen.forEach((_, index) => {
                updateData(value, `${GRUPPEN_PTR}/${index}/${COURTAGE_KEY}`)
            })
        },
        INIT_GRUPPENUNFALL: () => {
            loadCurrentLocationData("/gruppenunfalleinzel").then(() => {
                updateData(
                    getDataFromPointer(
                        "/gruppenunfalleinzel",
                    ).tarifierungGruppenUndEinzelUnfallList.filter(
                        (gruppe) => gruppe.nettobeitragProGruppe > 0,
                    ),
                    "/gruppenunfalleinzel/uebersicht",
                )
            })
        },
        GRUPPENUNFALL_SPEICHERN: () => {
            sendDataToBackend(
                getDataFromPointer("/gruppenunfalleinzel/_links/updateTarifierung"),
                getDataFromPointer("/gruppenunfalleinzel"),
            ).then((response) =>
                updateData(response?._data, "/gruppenunfalleinzel"),
            )
        },
        GRUPPENUNFALL_WEITER: () => {
            navigate(
                pathBuilder(
                    getDataFromPointer(
                        "/gruppenunfalleinzel/_links/loadGruppenUndEinzelUnfallZusammenfassung",
                    ),
                ),
            )
        },
        CREATE_EXCEL: () => {
            sendDataToBackend(
                getDataFromPointer(
                    "/gruppenunfalleinzel/_links/exportExcelGruppenunfall",
                ),
                {},
            ).then((response) => {
                toast.success(
                    "Excelliste wurde erfolgreich im Druckcenter abgelegt",
                )
                downloadDocument(response)
            })
        },
    }
}
